import "core-js/modules/es.array.concat.js";
import { Card, Flex, Text } from '@applyboard/crystal-ui';
import React from 'react';
import { IllustrationGenericCurrency } from "./IllustrationGenericCurrency";
export function TotalRevenueGenerated(_ref) {
  var totalEarned = _ref.totalEarned,
    selectedCurrency = _ref.selectedCurrency,
    selectedCategory = _ref.selectedCategory;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Flex, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(IllustrationGenericCurrency, null))), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyS",
    contrast: "mid"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, selectedCategory ? "Total ".concat(selectedCategory.toLowerCase(), ":") : "Total:")), /*#__PURE__*/React.createElement(Text, {
    variant: "titleL",
    contrast: "mid"
  }, formatCurrency(totalEarned, selectedCurrency.value))));
}
function formatCurrency(amount, currency) {
  var symbol;
  switch (currency) {
    case 'CAD':
    case 'USD':
    case 'AUD':
      symbol = '$';
      break;
    case 'EUR':
      symbol = '€';
      break;
    case 'GBP':
      symbol = '£';
      break;
    default:
      symbol = '$';
      break;
  }
  return "".concat(symbol).concat(amount.toLocaleString());
}